import React, { useEffect, useState } from "react";
import axios from "axios";
import baseUrl from "../../../baseUrl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Spinner/Spinner";

const CreateExam = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));

  const [showModal, setShowModal] = useState(false);

  const [examTitle, setExamTitle] = useState("");
  const [examCode, setExamCode] = useState("");
  const [examCenter, setExamCenter] = useState("");
  const [examStartAt, setExamStartAt] = useState("");
  const [examEndAt, setExamEndAt] = useState("");
  const [examSubject, setExamSubject] = useState("");
  const [examInstruction, setExamInstruction] = useState("");

  const [batches, setBatches] = useState([]);
  const [batchId, setBatchId] = useState("");

  const [loading, setLoading] = useState(false);

  const clearFields = () => {
    setExamTitle("");
    setExamCode("");
    setExamCenter("");
    setExamStartAt("");
    setExamEndAt("");
    setExamSubject("");
    setExamInstruction("");
  };

  const navigate = useNavigate();

  // for loading batches list
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/get-all-batches`, {
        headers: { Authorization: `Bearer ${adminToken}` },
      })
      .then((res) => {
        if (res.data.success === true) {
          setBatches(res.data.batches);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [adminToken]);

  // handle submit for create exam
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(`Batch Id is ${batchId}`);
    setLoading(true);
    axios
      .post(
        `${baseUrl}/admin/create-exam`,
        {
          examTitle,
          examCode,
          examCenter,
          examStartAt,
          examEndAt,
          examSubject,
          examInstruction,
          batchId,
        },
        {
          headers: {
            Authorization: `Bearer ${adminToken}`,
          },
        }
      )
      .then((res) => {
        console.log(batchId);
        if (res.data.success === true) {
          toast.success(res.data.message);
          navigate("/admin/exams");
          clearFields();
          window.location.reload();
        } else {
          toast.error(res.data.message);
          navigate("/admin/exams");
          clearFields();
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });

    setShowModal(false);
  };

  return (
    <>
      {loading && <Spinner />}
      <button
        className="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
        type="button"
        onClick={() => setShowModal(true)}
      >
        <i className="fa-solid fa-plus mr-1"></i> Create Exam
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-3xl font-semibold">Create Exam</h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>

                {/*body*/}
                <form onSubmit={handleSubmit}>
                  <div className="relative p-6 flex-auto">
                    <label
                      className="block mb-2 text-sm font-bold text-gray-700"
                      htmlFor="examTitle"
                    >
                      Exam Title
                    </label>
                    <input
                      className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-green-500 border-green-300 focus:shadow-outline"
                      type="text"
                      name="examTitle"
                      value={examTitle}
                      onChange={(e) => setExamTitle(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-4 md:flex">
                    <div className="mb-4 md:mr-2 md:mb-0 ml-2">
                      <label className="block mb-2 text-sm font-bold text-gray-700">
                        Exam Code
                      </label>
                      <input
                        className="w-full px-3 py-2 text-sm leading-tight focus:outline-green-500 border-green-300 text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        type="text"
                        name="examCode"
                        value={examCode}
                        onChange={(e) => setExamCode(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-4 md:mr-2 md:mb-0">
                      <label className="block mb-2 text-sm font-bold text-gray-700">
                        Exam Center
                      </label>
                      <input
                        className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        type="text"
                        name="examCenter"
                        value={examCenter}
                        onChange={(e) => setExamCenter(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-4 md:mr-2 md:mb-0">
                      <label className="block mb-2 text-sm font-bold text-gray-700">
                        Exam Subject
                      </label>
                      <input
                        className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        type="text"
                        name="examSubject"
                        value={examSubject}
                        onChange={(e) => setExamSubject(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="mb-4 md:flex">
                    <div className="pr-16  mb-4 md:mr-2 md:mb-0 ">
                      <label className="block mb-2 text-sm font-bold text-gray-700">
                        Exam Start At
                      </label>
                      <input
                        className="w-full px-3 py-2 text-sm leading-tight focus:outline-green-500 border-green-300 text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        type="datetime-local"
                        name="examStartAt"
                        value={examStartAt}
                        onChange={(e) => setExamStartAt(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-4 md:mr-2 md:mb-0">
                      <label className="block mb-2 text-sm font-bold text-gray-700">
                        Exam End At
                      </label>
                      <input
                        className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        type="datetime-local"
                        name="examEndAt"
                        value={examEndAt}
                        onChange={(e) => setExamEndAt(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-4 md:mr-2 md:mb-0">
                      <label className="block mb-2 text-sm font-bold">
                        Batch Name
                      </label>
                      <div className="relative inline-flex self-center">
                        <i className="fa-solid fa-angle-down text-white bg-green-400 absolute top-0 right-0 m-2 pointer-events-none  rounded"></i>

                        <select
                          name="batchId"
                          onChange={(e) => setBatchId(e.target.value)}
                          className="text-sm font-bold rounded border-2 border-green-300 text-gray-600 h-10 w-40 pl-5  bg-white hover:border-gray-400 focus:outline-none appearance-none"
                        >
                          <option name="batchId" value="0">
                            Select Batch
                          </option>
                          {batches.map((batch) => (
                            <option
                              name="batchId"
                              key={batch._id}
                              value={batch._id}
                            >
                              {batch.batchName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="relative p-6 flex-auto">
                    <label
                      className="block mb-2 text-sm font-bold text-gray-700"
                      htmlFor="examTitle"
                    >
                      Exam Instruction
                    </label>
                    <textarea
                      className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-green-500 border-green-300 focus:shadow-outline"
                      name="examInstruction"
                      value={examInstruction}
                      onChange={(e) => setExamInstruction(e.target.value)}
                      required
                      rows="3"
                    ></textarea>
                  </div>
                  {/*body*/}
                  {/*footer*/}
                  <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                    <button
                      className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                    <button
                      className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="submit"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default CreateExam;
